import {AxiosError} from 'axios'
import {UseMutationOptions} from 'react-query'

import {API} from '../../../networking/http'
import {SubscriptionFormType} from '../../../services/subscription/forms/subscription-purchase-form'
import {SubscriptionBooking} from '../../subscription-bookings/types'
import {useVenue} from '../../venue/hooks'

export type PayByTokenParams = {
  data: SubscriptionFormType['subscriptionDraft']
  entityId: string
  sum: number | string
  venueId: string
  paymentMethodId: string | null
  currency: string
  installmentAmount?: number
}

export type PaySubscriptionOptions = NonNullable<PayByTokenParams>

export type PaySubscriptionQueryReturnType = {
  bookingData: SubscriptionBooking
} | null

export type PaySubscriptionByTokenMuOp = UseMutationOptions<
  PaySubscriptionQueryReturnType,
  AxiosError,
  PaySubscriptionOptions
>
export const paySubscriptionEndpoint = 'memberships/byToken'

export const paySubscriptionByTokenMutation = (params?: PaySubscriptionByTokenMuOp): PaySubscriptionByTokenMuOp => {
  // TODO: move onSu and onEr to service
  const {data: venue} = useVenue()
  return {
    mutationFn: async (options: PaySubscriptionOptions) => {
      if (!venue) {
        return Promise.resolve(null)
      }
      const res = await API.post<PaySubscriptionOptions, PaySubscriptionQueryReturnType>(
        paySubscriptionEndpoint,
        options,
      )
      return res.data
    },
    ...params,
  }
}
